/* unplugin-vue-components disabled */import script from "./Subtitle.vue?vue&type=script&setup=true&lang=js"
export * from "./Subtitle.vue?vue&type=script&setup=true&lang=js"

import "./Subtitle.vue?vue&type=style&index=0&id=17be4b04&scoped=true&lang=less"

import exportComponent from "/var/lib/jenkins/workspace/prod-fe.pro/src/fe-pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-17be4b04"]])

export default __exports__